module.exports = __webpack_public_path__ + "static/media/anim-7-timing.168381c6.png";